import { useEffect, useState } from "react";
import { FilterModal } from "../modal/advance-filter-modal";
import { getAuthModalData } from "../../content/advance-search-login-modal";

interface OpenAuthModalEvent extends CustomEvent {
  detail: {
    modalType?: string;
  };
}

export default function AuthModalManager() {
  const [modalData, setModalData] = useState(getAuthModalData("course"));
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Sample modal data - replace with your actual data

  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    const openModal = (event: OpenAuthModalEvent) => {
      const modalType = event.detail.modalType || "course"; // Default to "course"
      setModalData(getAuthModalData(modalType));
      setIsModalOpen(true);
    };

    window.addEventListener("openAuthModal", openModal as EventListener);

    return () => {
      window.removeEventListener("openAuthModal", openModal as EventListener);
    };
  }, []);

  return (
    <FilterModal
      open={isModalOpen}
      handleOpen={handleToggleModal}
      advanceSearchLoginModaldata={modalData}
    />
  );
}
